/**
 * Sometimes, the page is hosted by MedCapture in a webview.
 * This means window.parent is not the parent window, but the current one (self).
 * This utility helps to find the real parent window.
 */

let parentWindow = null;
window.addEventListener('message', ({ data, source }) => {
  if (data?.type === 'medcapture_webview_ready') {
    parentWindow = source;
  }
});

/**
 * Returns true if the current window is in a webview or iframe.
 */
export const hasParentWindow = () => {
  return parentWindow || window.self !== window.top;
};

export const getParentWindow = () => {
  return parentWindow || window.parent;
};
